import { Component, Injector, inject } from "@angular/core";
import { MatPaginatorModule } from "@angular/material/paginator";
import { FilterDataType, MatTableCrudComponent } from "../../../shared/components/mat-table-crud/mat-table-crud.component";
import { MatTableCrudService } from "../../../shared/components/mat-table-crud/mat-table-crud.service";
import { GenericFilterPipe } from "../../../shared/pipes/generic-filter.pipe";
import { AuthorisationService } from "../../../shared/services/authorisation.service";
import { CommonService } from "../../../shared/services/common.service";
import { ConfigurationService } from "../../../shared/services/configuration.service";
import { PlatformType, Station } from "../../calendars/calendars.models";
import { AdministrationService } from '../administration.service';
import { StationEditComponent } from "./station-edit.component";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatOptionModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { QueryClient } from "@tanstack/angular-query-experimental";
import { Subscription } from "rxjs";


@Component({
  templateUrl: './stations.component.html',
  styleUrls: ['./stations.component.scss', '../../../shared/components/mat-table-crud/mat-table-crud.component.scss'],
  providers: [MatTableCrudService],
  standalone: true,
  imports: [MatCardModule, MatButtonModule, MatIconModule, MatTableModule, MatSortModule, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatSelectModule, MatOptionModule, MatPaginatorModule, GenericFilterPipe]
})
export class StationsComponent extends MatTableCrudComponent<Station>
{
  public StationNameFilter: any;
  public StateFilter: any;
  public StationTypeIdFilter: any;
  public PlatformTypeIdFilter: any;

  private queryClient = inject(QueryClient);

  private onDataFetchedSubscription: Subscription;

  constructor(
    public authorisationService: AuthorisationService,
    protected injector: Injector,
    public commonService: CommonService,
    public configurationService: ConfigurationService,
    public administrationService: AdministrationService)
  {
    super(injector,
      StationEditComponent,
      StationEditComponent,
      StationEditComponent,
      "CreateStation",
      "DeleteStation",
      "GetStationsServer",
      "UpdateStation",
      configurationService.cbSettings().adminServiceUrl,
      configurationService.cbSettings().adminServiceUrl,
      configurationService.cbSettings().adminServiceUrl,
      configurationService.cbSettings().adminServiceUrl);

    this.changedByField = "ChangedByUserId";
    this.ServerPaging = true;

    this.displayedColumns = ['Id', 'StationName', 'State', 'StationType.StationTypeName', 'PlatformType.Name'];
    this.filteredValues = [
      { Field: "StationName", Value: "", Path: "", DataType: FilterDataType.String },
      { Field: "State", Value: "", Path: "", DataType: FilterDataType.String },
      { Field: "StationTypeId", Value: "", Path: "StationType.Id", DataType: FilterDataType.Number },
      { Field: "PlatformTypeId", Value: "", Path: "PlatformType.Id", DataType: FilterDataType.Number }
    ];

    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.hasBackdrop = true;
    this.dialogConfig.width = "65rem";

    this.CanAdd = this.authorisationService.hasPermission(this.authorisationService.Permissions.AddStations);
    this.CanEdit = this.authorisationService.hasPermission(this.authorisationService.Permissions.EditStations);
    this.CanDelete = this.authorisationService.hasPermission(this.authorisationService.Permissions.DeleteStations);
  }

  ngOnInit(): void
  {
    super.ngOnInit();

    this.onDataFetchedSubscription = this.mtCrudService.OnDataFetched.subscribe((result: any) =>
    {
      this.queryClient.invalidateQueries({
        type: "all", exact: false, predicate: (query: any) =>
        {
          return query.queryKey[0] == "Stations";
        }
      });
    });
  }

  addNew(event: any)
  {
    const platformType: PlatformType = this.administrationService.platformTypes().filter(p => p.Id == this.commonService.stationPlatformTypeId)[0];

    this.addedItem.PlatformType = platformType;
    this.addedItem.PlatformTypeId = this.commonService.stationPlatformTypeId;
    this.addedItem.SortOrder = 0;
    this.addedItem.DaysUntilDropDead = this.configurationService.cbSettings().defaultPodcastDaysUntilDropDead;

    super.addNew(event);
  }

  deleteItem(event: any, station: Station)
  {
    this.deleteConfirmationMessage = `Are you sure you want to delete this platform (${station.StationName})?`;
    this.deleteHeaderText = "Delete Platform?";

    super.deleteItem(event, station);
  }



  ngOnDestroy()
  {
    // prevent memory leak when component destroyed
    if (this.onDataFetchedSubscription)
    {
      this.onDataFetchedSubscription.unsubscribe();
    }

    super.ngOnDestroy();
  }











}

